import React from "react";
import logo from "./assets/devtrexapp.png";
import "./policy.css";

const PrivacyPolicy = () => {
  return (
    <div className="policy-wrapper">
      {/* Header */}
    <header className="policy-header">
  <div className="logo-box">
    <img src={logo} alt="Devtrex Logo" className="logo" />
  </div>
  <h1>Privacy Policy</h1>
  <p className="app-name">RKG ECOTEX</p>
</header>


      {/* Content */}
      <div className="policy-container">
        <p className="updated">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <h2>Introduction</h2>
        <p>
          RKG ECOTEX respects the privacy of its users. This Privacy Policy
          explains how information is handled when using the RKG ECOTEX mobile
          application, designed for plastic and bottle scrap merchants.
        </p>

        <h2>Information Collection</h2>
        <p>
          The app does not collect personal information such as name, phone
          number, email address, or payment details.
        </p>

        <h2>Location Access</h2>
        <p>
          The app provides company location details. When users tap
          <strong> “Go to Location”</strong>, Google Maps opens for navigation.
          RKG ECOTEX does not track or store user location data.
        </p>

        <h2>Notification Permission</h2>
        <p>
          Notification permission is used only to notify users about daily
          plastic scrap rate updates and important company announcements.
          Notifications can be disabled anytime from device settings.
          Notification Tokens

RKG ECOTEX may use a device notification token to deliver important notifications such as scrap rate updates and company announcements.

The notification token is used only for sending notifications and is not used for tracking, analytics, advertising, or any other miscellaneous purposes.

        </p>

        <h2>Third-Party Services</h2>
        <p>
          The app may use third-party services such as Google Maps and
          notification providers. These services operate under their own
          privacy policies.
        </p>

        <h2>Children’s Privacy</h2>
        <p>
          This application is intended for business use and is not designed for
          children under the age of 13.
        </p>

        <h2>Contact Information</h2>
        <div className="contact-box">
          <p><strong>Developer:</strong> Pranav Bhosale</p>
          <p><strong>Company:</strong> Devtrex App Development</p>
          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:devtrexapp@gmail.com">
              devtrexapp@gmail.com
            </a>
          </p>
        </div>
      </div>

      {/* Footer */}
      <footer className="policy-footer">
        <p>© {new Date().getFullYear()} Devtrex App Development</p>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
